import { TextField } from "@mui/material";

interface SearchFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  minWidth?: number;
}

export default function SearchBox({
  label = "Search",
  value,
  onChange,
  minWidth = 300,
}: SearchFieldProps) {
  return (
    <TextField
      label={label}
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth }}
    />
  );
}
